import React from 'react';
import { PaymentLinksSVG } from '../../../components';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../styles/theme';

export default function PaymentMovementsHeader () {
    const { t } = useTranslation();
    return (
        <Box className='dropHeader'>
            <Box className='svgIcon'>
                <PaymentLinksSVG customStroke={palette.secondary[600]}/>
            </Box>
            <Typography variant='pageHeaderTitle' className='headerText'>{t('paymentMovements.table.title')}</Typography>
        </Box>
    );
}
